import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  styleUrls: ['./about-us.component.scss'],
  templateUrl: './about-us.component.html'
})

export class AboutUsComponent implements OnInit {

  ngOnInit() {
    const body = document.getElementById('body');
    function bodyClass() {
      if (body.classList.contains('home-pg')) {
        body.classList.remove('home-pg');
      }
    }
    bodyClass();
  }
}
